import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlsCartRoutingModule } from './controls-cart-routing.module';
import { ControlsCartComponent } from './controls-cart.component';
import { CustomFlexLayoutModule } from 'src/app/flex-layout/custom-flex-layout.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '../shared.module';
import { DirectiveModule } from '../utils/directive/directive.module';


@NgModule({
  declarations: [
    ControlsCartComponent
  ],
  imports: [
    CommonModule,
    ControlsCartRoutingModule,
    CustomFlexLayoutModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    SharedModule,
    DirectiveModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule

  ], exports:[ControlsCartComponent]
})
export class ControlsCartModule { }
